export default "__VITE_ASSET__D5sE3O24__"